module.exports = __webpack_public_path__ + "img/chat.002270c9.png";